<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="data.data"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >

            <template slot="actions" slot-scope="{ item }">
                <b-button size="sm" variant="primary" v-if="userCan('update-venue-users')" @click="manageVenueUsers(item)"><i class="fa fa-users"></i></b-button>
                <b-button size="sm" variant="primary" v-if="userCan('update-venue')" @click="updateVenue(item)"><i class="fa fa-pencil"></i></b-button>
                <b-button size="sm" variant="danger" v-if="userCan('delete-venue')" @click="removeVenue(item)"><i class="fa fa-trash"></i></b-button>
            </template>
        </app-data-table>
        <app-pop-up
            id="manage-users-window"
            :title="`Administración de usuarios para la sede ${selectedVenue.name}`"
            size="large"
        >
            <template slot="body">
                <div>
                    <div v-if="!isLoaded">
                        <b-row align-h="center">
                            <b-col cols="2"><app-preloading></app-preloading></b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <app-sub-title text="Seleccione usuarios de la sede"></app-sub-title>                        
                        <b-checkbox v-for="user in clientUsers" :key="user.id" :value="user.id" v-model="selectedVenueUsers">{{ user.name }} - {{ user.email }}</b-checkbox>
                    </div>
                </div>
            </template>
            <template slot="buttons">
                <b-btn variant="confirm" @click="saveVenueUsers">
                    <i class="fa fa-save"></i> Aceptar
                </b-btn>
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import usersRepository from '@repositories/users.repository';
import venuesRepository from '@repositories/venues.repository';
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields: [                
                    {
                        key: 'name',
                        label: 'Nombre',
                        filter: true
                    },
                    {
                        key: 'description',
                        label: 'Descripción',
                        filter: true
                    },
                    {
                        key: 'city.name',
                        label: 'Ciudad',
                        sortable: false
                    },
                    {
                        key: 'address',
                        label: 'Dirección',
                        filter: true
                    },
                    {
                        key: 'actions',
                        label: 'Acciones'
                    }
                ],
            venueUsers: [],
            selectedVenueUsers: [],
            selectedVenue: '',
            clientUsers: [],
            isLoaded: false
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        updateVenue(data){
            this.$emit('update-venue', data);
        },
        removeVenue(data){
            this.$emit('remove-venue', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
        manageVenueUsers(venue) {
            this.selectedVenue = venue;
            Promise.all([
                this.loadClientUsers(venue.client_id),
                this.loadVenueUsers(venue.id)
            ])
            .then(data => {
                this.clientUsers = data[0];
                this.selectedVenueUsers = data[1].map(item => item.id);
            })
            .catch(error => {
                this.handleErrors(error);
            })
            .finally(() => (this.isLoaded = true));
            this.$bus.$emit('manage-users-window.open');
            
        },
        async loadClientUsers(clientId) {
            
            const ur = {...usersRepository};
            // try {
                const payload = {
                    fields: ['id', 'name', 'email'],
                    client: clientId,
                    profileSlug: 'cliente-admin'
                };
                const { data } = await ur.simple(payload);
                return data;
            // } catch (errors) {
            //     this.handleErrors(errors);
            // }
        },
        async loadVenueUsers(venueId) {
            const vr = {...venuesRepository};
            const { data } = await vr.getVenueUsers(venueId);
            return data;
        },
        async saveVenueUsers() {
            const vr = {...venuesRepository};
            try {
                const { data } = await vr.saveVenueUsers(this.selectedVenueUsers, this.selectedVenue.id);
                this.reset();
                toastr.success('Usuarios de la sede actualizados');
                this.$bus.$emit('manage-users-window.close');
            } catch (err) {
                this.handleErrors(err);
            }
        },
        reset() {
            this.selectedVenue = '';
            this.selectedVenueUsers = [];
            this.isLoaded = false;
        }
    }
}
</script>